module.exports = __webpack_public_path__ + "static/media/phone.1ea494c4.svg";